import { LoadingOutlined } from "@ant-design/icons";
import { Modal } from "antd";

interface Props {
    visible: boolean;
}

const WebsocketReconnectModal = ({visible}: Props) => {

    return (
        <Modal
            visible={visible}
            onCancel={() => {}}
            footer={false}
            className="custom-modal disable-modal-close"
        >
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <div>Đang kết nối hệ thống...</div>
                <LoadingOutlined />
            </div>
        </Modal>
    )
}

export default WebsocketReconnectModal;